import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface AddEducationToCandidateResponse extends BackendResponse {}
export interface AddEducationToCandidateParameters extends NextApiParams {
  from: string;
  to: string | null;
  comment: string;
  references: string;
  school: string;
  educationType: number;
  expirationDate: string | null;
}

export const addEducationToCandidate = withNextApi<
  AddEducationToCandidateResponse,
  AddEducationToCandidateParameters
>("/cvp/CvpAddEducationToCandidate");
